var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"TestView"}},[_c('NavBar'),_c('Modal',{attrs:{"isCreate":true,"uniqueID":'fdfgfd1',"recordBook":{},"entryData":{}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }